import { FC } from 'react'
import { AdditionalServicesProtocolSpaces } from 'components/AdditionalServices'
import { UserProtectedRoute } from 'routes'

const AdditionalServicesProtocolSpacesPage: FC = () => {
  return (
    <UserProtectedRoute>
      <AdditionalServicesProtocolSpaces />
    </UserProtectedRoute>
  )
}

export default AdditionalServicesProtocolSpacesPage
